import { Stack } from "@mui/material";

import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { useCurrentTenantInfoV2 } from "@/common/hooks/entity/tenant/useCurrentTenantInfoV2";
import { apiClient } from "@/core/api/ApiClient";
import { RoleDto } from "@/core/api/generated/v1";

import PermissionList from "../../Permission/PermissionList";
import TextLineListSkeleton from "../../Skeleton/TextLineListSkeleton";

interface Props {
  role: RoleDto;
}

export default function RolePermissionList({ role }: Props) {
  const tenantInfo = useCurrentTenantInfoV2();

  const globalRolePermissionsRequest = useApiRequest(
    apiClient.accountAdminApi.apiV1AdminAccountGlobalRolesRoleIdPermissionsGet,
    {
      roleId: role.id || "",
    },
    { skip: !tenantInfo.isGlobalContext || role.isScoped },
  );

  const tenantRolePermissionsRequest = useApiRequest(
    apiClient.tenantAccountApi.apiV1TenantAccountRolesRoleIdPermissionsGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      roleId: role.id || "",
    },
    { skip: !tenantInfo.isTenantContext || !role.isScoped },
  );

  const isLoading =
    globalRolePermissionsRequest?.isLoading || tenantRolePermissionsRequest.isLoading;
  const permissions =
    globalRolePermissionsRequest?.data || tenantRolePermissionsRequest.data || undefined;

  if (isLoading) {
    return <TextLineListSkeleton />;
  }

  return (
    <Stack direction='column' spacing={1}>
      <PermissionList permissions={permissions} />
    </Stack>
  );
}
